import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { MainFilterItem } from '../models/mainFilterItem';
import { MobileAppRanking } from '../models/mobileAppRanking';
import {
  CTV_STI_OPTIONS,
  ReportConfig,
  SELLER_REPORT_CONFIG
} from '../REPORT_CONFIG';
import { Observable } from 'rxjs';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';
import { RankingsService } from '../../../../services/rankings.service';
import { MobileAppStiRanking } from '../models/mobileAppStiRanking';
import { GridHeader } from '../models/gridHeader';
import { GroupType } from '../types/group-type';
import { ActivatedRoute } from '@angular/router';

declare let jQuery: any;

@Component({
  selector: 'app-rankings-seller-table',
  templateUrl: './rankings-seller-modal-table.component.html',
  styleUrls: [
    './rankings-seller-modal-table.component.scss',
    '../rankings-responsive.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RankingsSellerTableComponent implements OnInit, OnChanges {
  @Output() close = new EventEmitter<void>();

  regionFilters = ['All', 'APAC', 'EMEA', 'LATAM', 'NA'];
  platformFilters = [...CTV_STI_OPTIONS];
  bp$: Observable<Breakpoint>;
  gridData: Array<MobileAppRanking>;
  noResult = false;
  regionFilter: string[] = ['All'];
  sortHeader: GridHeader;
  rankingGridHeaders: GridHeader[];
  loadingData = false;
  currentConfig: ReportConfig;
  currentMainFilterItems: Array<MainFilterItem>;

  @Input()
  selectedGroup: string;

  @Input()
  selectedPlatform: string;

  @Input()
  selectedDate: string;

  @Input()
  selectedSeller: MobileAppStiRanking;

  constructor(
    private _route: ActivatedRoute,
    private _mediaQueryService: MediaQueryService,
    private _rankingsService: RankingsService,
    private _changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.bp$ = this._mediaQueryService.activeBreakpoint$;
    this.currentConfig = SELLER_REPORT_CONFIG[0];
    this.currentMainFilterItems = this.currentConfig.mainFilterItems;
    this.sortHeader = this.currentConfig?.gridHeaders[1];
    this.updateRankingGridHeaders();
    this._rankingsService.route = this._route;
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (!(propName === 'selectedGroup' || propName === 'selectedSeller')) {
        continue;
      }
      if (this.selectedGroup && this.selectedSeller) {
        this.loadRankingsData();
        this.updateRankingGridHeaders();
      }
    }
  }

  loadRankingsData() {
    let regions: string[] = this.regionFilter;
    if (this.regionFilter[0] == 'All') {
      regions = this.regionFilters.slice(1);
    }

    let additionalQueryString = regions
      .map(region => `parentRegion=${region}`)
      .join('&');

    if (this.selectedPlatform) {
      additionalQueryString = additionalQueryString.concat(
        `&platformName=${this.selectedPlatform}`
      );
    }

    this.loadingData = true;

    void this._rankingsService
      .getRankingsData(
        'sellerTrustIndex',
        this.selectedGroup,
        0,
        1000,
        `${additionalQueryString}&isRegion=false&date=${this.selectedDate}&sellerId=${this.selectedSeller.sellerId}`
      )
      .then(response => {
        if (response && response['docs']) {
          this.gridData = response['docs'];
          this.noResult = this.gridData.length === 0;
          setTimeout(() => {
            jQuery('img.sicon').on('error', function () {
              jQuery(this).css('opacity', '0');
            });
          }, 100);
        }
      })
      .finally(() => {
        this.loadingData = false;
        this._changeDetector.detectChanges();
        this._changeDetector.markForCheck();
      });
  }

  selectPlatform(platform: string) {
    if (platform == this.selectedPlatform) return;
    this.selectedPlatform = platform;
    this.loadRankingsData();
  }

  selectRegion(region: string) {
    if (region == 'All') {
      this.regionFilter = ['All'];
    } else {
      const allIndex = this.regionFilter.indexOf('All');
      if (allIndex > -1) {
        this.regionFilter.splice(allIndex, 1);
      }

      const index = this.regionFilter.indexOf(region);
      if (index > -1) {
        this.regionFilter.splice(index, 1);
      } else {
        this.regionFilter.push(region);
      }

      if (this.regionFilter.length == 0 || this.regionFilter.length == 4) {
        this.regionFilter = ['All'];
      }
    }

    this.loadRankingsData();
  }

  toggleSort(selectedGridHeader: GridHeader) {
    selectedGridHeader.sort =
      !selectedGridHeader.sort || selectedGridHeader.sort == 'sort-asc'
        ? 'sort-desc'
        : 'sort-asc';
    this.sortHeader = selectedGridHeader;
  }

  updateRankingGridHeaders() {
    if (this.currentConfig?.gridHeaders) {
      this.rankingGridHeaders = this.currentConfig.gridHeaders.filter(
        header =>
          !header.groups ||
          header.groups.includes(this.selectedGroup as GroupType)
      );
    }
  }

  onClose() {
    this.close.emit();
  }
}
